// extracted by mini-css-extract-plugin
export default {"full":"styles_full__bneVD"};